var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.667 13.333V9.185c0-1.375.561-2.694 1.562-3.666A5.4 5.4 0 0 1 15.999 4c1.415 0 2.772.546 3.772 1.519a5.11 5.11 0 0 1 1.562 3.666v4.148M3.778 10.667h24.444c.614 0 1.111.456 1.111 1.02V26.98c0 .564-.497 1.02-1.11 1.02H3.777c-.614 0-1.111-.456-1.111-1.02V11.686c0-.563.497-1.02 1.11-1.02"
  })));
};
export default SvgBriefcase;